// extracted by mini-css-extract-plugin
export default {"root":"_3OQq0","navbar":"_30h7X","btn-roster":"_3sX-v","btnRoster":"_3sX-v"};